import MainMenuItem from './MainMenuItem'

export default MainMenuItem
